import React from 'react'
import image1 from '../images/contact.jpg'
import logo from '../images/logo.png'

const Contact = () => {
  return (
    <div
      style={{
        backgroundImage: 'url(' + image1 + ')',
        backgroundRepeat: 'no-repeat'
      }}
      className='bg-cover'
    >
      <div
        id='contact'
        className='text-blue-500 py-15 text-3xl font-medium flex justify-center items-center flex-col w-screen222 text-center'
      >
        <div className='text-lg font-medium text-blue-500 mb-3'>Contact Us</div>
        <img src={logo} width='350px' alt='logo' />
        <div className='flex flex-row text-gray-800 flex-wrap justify-center items-center gap-x-5 gap-y-20 mb-32'>
          <div className='bg-white mt-10 shadow-2xl p-10 rounded-2xl'>
            <div className=''>
              <form>
                <div className='w-full flex flex-col gap-y-5'>
                  <div className='flex flex-row flex-wrap justify-center gap-x-5 gap-y-5 items-center'>
                    <input
                      className='border-2 w-full rounded-lg p-2 text-lg'
                      placeholder='Name'
                    ></input>
                    <input
                      className='border-2 rounded-lg p-2 text-lg w-full'
                      placeholder='Your Email'
                    ></input>
                  </div>
                  <input
                    className='border-2 rounded-lg p-2 text-lg w-full'
                    placeholder='Your Subject'
                  ></input>
                  <textarea
                    className='border-2 rounded-lg p-2 text-lg w-full'
                    placeholder='Type your message'
                  ></textarea>
                </div>
              </form>
            </div>

            <button className='bg-blue-900 text-white text-sm mt-5 float-left py-1 px-2 hover:bg-blue-800 hover:shadow-md transition-all duration-300 hover:scale-110 rounded-3xl'>
              Send a Message
            </button>
          </div>
          <div className='flex flex-col text-base gap-y-3 font-normal'>
            <div className='p-8 bg-white shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 duration-700 rounded-2xl'>
              <h3>Visit Us!</h3> <p>99 Wall Street, Suite 1390, New York, NY 10005</p>
            </div>
            <div className='p-8 bg-white shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 duration-700 rounded-2xl'>
              <h3>Call Us!</h3> <p>347-374-8005</p>
            </div>
            <div className='p-8 bg-white shadow-xl hover:shadow-2xl transition-all hover:-translate-y-2 duration-700 rounded-2xl'>
              <h3>Contact Us!</h3> <p>info@wirelessstore.com</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Contact
